export const LOGIN_INFO_REQUEST = 'LOGIN_INFO_REQUEST'
export const LOGIN_INFO_SUCCESS = 'LOGIN_INFO_SUCCESS'
export const LOGIN_INFO_ERROR = 'LOGIN_INFO_ERROR'
export const RESET_LOGIN_INFO = 'RESET_LOGIN_INFO'
